import { Element } from './Element'

export class TitleElement extends Element {
  override type = 'title'
}
